var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlossary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12V10.5H21V12H9Z",
    fill: "#A7A7A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75V14.25H21V15.75H9Z",
    fill: "#A7A7A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5V18H21V19.5H9Z",
    fill: "#A7A7A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4375 5.1H6.46875V2.4H23.4375V5.1ZM5.1 6.46875V23.4375H2.4V6.46875H5.1ZM24.9 23.4375V6.5625H27.6V23.4375H24.9ZM6.5625 24.9H23.4375V27.6H6.5625V24.9Z",
    fill: "#A7A7A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 2.7H2.7V4.8H4.8V2.7ZM0 0V7.5H7.5V0H0Z",
    fill: "#A7A7A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 25.2H2.7V27.3H4.8V25.2ZM0 22.5V30H7.5V22.5H0Z",
    fill: "#A7A7A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3 2.7H25.2V4.8H27.3V2.7ZM22.5 0V7.5H30V0H22.5Z",
    fill: "#A7A7A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3 25.2H25.2V27.3H27.3V25.2ZM22.5 22.5V30H30V22.5H22.5Z",
    fill: "#A7A7A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlossary);
export default __webpack_public_path__ + "static/media/icon-glossary.7189fa8764f7f3d6a3568865b600d469.svg";
export { ForwardRef as ReactComponent };